import type { Project } from "../types/project";

export const projects: Project[] = [
  {
    slug: "benefit-bridge",
    title: "Benefit Bridge",
    status: "shipped",
    problem:
      "Started as a plain-language explainer for new laws and ended up telling you which Canadian benefits you likely qualify for — describe your life in any language, get a rough amount and the official page for each.",
    decision:
      "The AI only extracts the facts. A deterministic rules engine makes the eligibility call, so the answer never depends on a model's guess.",
    callouts: [
      { label: "stack", value: "next.js + typescript" },
      { label: "data", value: "postgresql + supabase" },
      { label: "ai", value: "gemini extracts, rules engine decides" },
      { label: "built", value: "solo, hack the hill iii" },
    ],
    siteUrl: "https://benefit-bridge-hack-the-hill-iii.vercel.app/",
    sourceUrl: "https://github.com/shreyu1701/Benefit-Bridge-Hack-the-Hill-III",
  },
  {
    slug: "ai-wellness",
    title: "AI-Wellness",
    status: "shipped",
    problem:
      "A full-stack mood-tracking platform that turns daily check-ins into readable trends and AI-generated suggestions — built to feel like a habit, not a form.",
    decision:
      "Hardest part was the auth layer: session-based access control with bcrypt hashing, built so every route is protected by default rather than checked ad hoc.",
    callouts: [
      { label: "stack", value: "next.js + mongodb" },
      { label: "auth", value: "session-based, bcrypt" },
      { label: "ai", value: "openai api integration" },
      { label: "data", value: "7+ points per entry" },
    ],
    siteUrl: "https://ai-wellness-psi.vercel.app/",
  },
  {
    slug: "healthy-feast",
    title: "Healthy Feast",
    status: "shipped",
    problem:
      "A recipe platform built to handle real async state cleanly — search, filtering, and saved favorites without the usual loading-spinner sprawl.",
    decision:
      "Chose component-level state over a global store since the data doesn't need to persist across routes — kept the bundle lean and the logic traceable.",
    callouts: [
      { label: "stack", value: "react + tailwind" },
      { label: "state", value: "component-level" },
      { label: "focus", value: "async ux" },
    ],
    siteUrl: "https://healthy-feast.vercel.app/",
    sourceUrl: "https://github.com/shreyu1701/healthyFeast/",
  },
];
